module.exports = __webpack_public_path__ + "static/hero-ecef4b1016adcfd537d4a13e4ed2ef66.png";